function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { capitalize } from '@vue/shared';
export default {
  name: 'InformMassiveUpload',
  props: {
    // response.data
    tplToWork: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    tableauRecords: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      project: [],
      dataset: [],
      table: [],
      tableMessage: [],
      tableFields: [{
        label: 'Column Name',
        key: 'name'
      }, {
        label: 'Status',
        key: 'success'
      }, {
        label: 'Reason',
        key: 'message'
      }],
      headers: [{
        text: 'Column Name',
        value: 'name'
      }, {
        text: 'Status',
        value: 'success'
      }, {
        text: 'Reason',
        value: 'message',
        width: '55%'
      }]
    };
  },
  created: function created() {
    this.getDataFromName();
  },
  methods: {
    capitalize: function capitalize(text) {
      if (!text) return '';
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    // Estado del registro: por columnas si las trae, si no por su propio success
    isRecordOk: function isRecordOk(element) {
      var normalized = this.normalizeColumns(element.columns || []);
      if (normalized.length) {
        return normalized.every(function (rec) {
          return rec.success;
        });
      }
      return element.success !== false;
    },
    // Dedup por columna priorizando errores
    normalizeColumns: function normalizeColumns(raw) {
      if (!Array.isArray(raw)) return [];
      var chosen = new Map();
      var _iterator = _createForOfIteratorHelper(raw),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          var prev = chosen.get(item.name);
          if (!prev) {
            chosen.set(item.name, item);
          } else if (item && prev && item.success === false && prev.success === true) {
            chosen.set(item.name, item);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return Array.from(chosen.values()).sort(function (a, b) {
        return Number(a.success) - Number(b.success);
      });
    },
    countsText: function countsText(raw) {
      var cols = this.normalizeColumns(raw || []);
      var errs = cols.filter(function (c) {
        return c && c.success === false;
      }).length;
      var oks = cols.filter(function (c) {
        return c && c.success === true;
      }).length;
      return "Errors: ".concat(errs, " \u2022 Ok: ").concat(oks, " \u2022 Total: ").concat(cols.length);
    },
    getDataFromName: function getDataFromName() {
      var _this = this;
      console.log(this.tplToWork);
      this.tplToWork.forEach(function (element) {
        var aux = (element.name || '').split(',');
        _this.project.push((aux[0] || '').trim());
        _this.dataset.push((aux[1] || '').trim());
        _this.table.push((aux[2] || '').trim());
        var normalized = _this.normalizeColumns(element.columns || []);
        var ok;
        if (normalized.length) {
          ok = normalized.every(function (rec) {
            return rec.success;
          });
        } else {
          // Registros sin detalle de columnas (ej. metadata de tablas campo-valor):
          // el estado viene en el propio registro
          ok = element.success !== false;
        }
        if (ok) {
          _this.tableMessage.push('La metadata se ha cargado correctamente.');
        } else {
          _this.tableMessage.push(element.message || 'La carga no pudo completarse debido a errores en la metadata. Por favor, revísela.');
        }
      });
    }
  }
};